import axios from 'axios';
import retryx from 'retryx';
import jwt_decode from 'jwt-decode';
import Util from './Util';

const ONE_DAY_MS = 1000 * 60 * 60 * 24;
const REFRESH_TOKEN_EXPIRE_MARGIN = 7 * ONE_DAY_MS;
const RESPONSE_TYPE = {
	REFRESH_TOKEN: 'refresh_token',
	ACCESS_TOKEN: 'access_token',
};
const GRANT_TYPE = {
	REFRESH_TOKEN: 'refresh_token',
};
const RETRY_COUNT = 5;
export default class TokenManager {
	static isExpiredToken(token, margin) {
		if(!token)
			return true;
		if (margin === undefined)
			margin = 0;
		
		let expired = Util.getUTCFromYMDHMS(token.exp);
		let today = Date.now();
		
		return expired < (today + margin);
	}
	
	static isExpiredAccessToken(access_token){
		return TokenManager.isExpiredToken(access_token);
	}

	static isExpireSoonRefreshToken(refresh_token) {
		return TokenManager.isExpiredToken(refresh_token, REFRESH_TOKEN_EXPIRE_MARGIN);
	}
	
	static isExpiredRefreshToken(refresh_token) {
		return TokenManager.isExpiredToken(refresh_token);
	}
	
	static refreshTokenRequest(refresh_token){
		const params = new URLSearchParams();
		params.append('response_type', RESPONSE_TYPE.REFRESH_TOKEN);
		params.append('grant_type', GRANT_TYPE.REFRESH_TOKEN);
		params.append('refresh_token', refresh_token);
			
		return retryx(async () => {
			return axios.post('/auth/token', params)
				.then((res) => {
					return TokenManager.decode(res.data.refresh_token.token);
				});
		},{
			maxTries: RETRY_COUNT,
			retryCondition: (tries, reason) =>{
				TokenManager.retryCondition(reason);
			},
		});
	}
	
	static accessTokenRequest(refresh_token){
		const params = new URLSearchParams();
		params.append('response_type', RESPONSE_TYPE.ACCESS_TOKEN);
		params.append('grant_type', GRANT_TYPE.REFRESH_TOKEN);
		params.append('refresh_token', refresh_token);
		
		return retryx(async () => {
			return axios.post('/auth/token', params)
				.then((res) => {
					return TokenManager.decode(res.data.access_token.token);
				});
		},{
			maxTries: RETRY_COUNT,
			retryCondition: (tries, reason) =>{
				return TokenManager.retryCondition(reason);
			},
		});
	}
	
	static retryCondition(reason) {
		if(!reason.response)
			return true;
			
		let ret = true;
		switch (reason.response.status) {
		case 400: // �p�����[�^�G���[
		case 500: // �T�[�o�G���[
			ret = false;
			break;
		default:
			ret = true;
			break;
		}
		return ret;
	}
	
	static decode(token) {
		let payload = jwt_decode(token);
		payload.token = token;
		return payload;
	}
}
